import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonProps", "buttonText", "showCloseButton", "onClose", "title", "trackingName", "steps", "subTitle"];
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Carousel } from 'foundations-components/transitional/components/Carousel';
import { buildSlideshowSteps } from '../../utils/evaluationSlideshowModalUtils';
import { useTracker } from '../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EvaluationSlideshowModal = _ref => {
  let {
      buttonProps = {},
      buttonText,
      showCloseButton = true,
      onClose,
      title,
      trackingName,
      steps,
      subTitle
    } = _ref,
    modalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackSectionView,
    trackUserInteraction
  } = useTracker();
  const trackModalStepView = step => {
    trackUserInteraction(`visit modal step ${step}`, trackingName);
  };
  const handleClose = () => {
    trackUserInteraction('close modal', trackingName);
    onClose();
  };
  return /*#__PURE__*/_jsxs(Modal, Object.assign({}, modalProps, {
    onOpenComplete: () => {
      var _modalProps$onOpenCom;
      (_modalProps$onOpenCom = modalProps.onOpenComplete) === null || _modalProps$onOpenCom === void 0 || _modalProps$onOpenCom.call(modalProps);
      trackSectionView('view evaluation modal', trackingName);
      trackModalStepView(1);
    },
    use: "conversational",
    width: 800,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [showCloseButton && /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClose
      }), title && /*#__PURE__*/_jsx(Text, {
        as: "h1",
        marginBlockEnd: "300",
        children: title
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [subTitle && /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "0",
        children: subTitle
      }), /*#__PURE__*/_jsx(Carousel, {
        onStepIndexChange: evt => {
          trackModalStepView(evt.target.value + 1);
        },
        steps: buildSlideshowSteps(steps)
      })]
    }), buttonText && /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        "data-test-id": "evaluation-modal-cta-button",
        use: "primary"
      }, buttonProps, {
        onClick: evt => {
          trackUserInteraction('click on evaluation modal cta', trackingName);
          if (typeof buttonProps.onClick === 'function') {
            buttonProps.onClick(evt);
          }
        },
        children: buttonText
      }))
    })]
  }));
};
export default EvaluationSlideshowModal;